import { useEffect } from 'react';

import { useLogout } from 'hooks';

import { config } from 'miles.config';

export const useDetectActivity = () => {
  const [handleLogout] = useLogout();

  let timeout: NodeJS.Timeout;

  const resetTimerOnActivity = () => {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      handleLogout();
    }, config.inactiveTimeout);
  };

  useEffect(() => {
    const EVENTS = ['mousemove', 'mousedown', 'keydown', 'scroll', 'onblur'];

    EVENTS.forEach((event) => {
      window.addEventListener(event, resetTimerOnActivity);
    });

    return () => {
      EVENTS.forEach((event) => {
        window.removeEventListener(event, resetTimerOnActivity);
      });
    };
  }, []);

  useEffect(() => {
    resetTimerOnActivity();
  }, []);
};
